import { createContext, useContext, useEffect, useState } from "react";
import { http } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem("sisu_token")) {
      setUser(false);
      setLoading(false);
      return;
    }
    http
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const persist = (data) => {
    if (data?.token) localStorage.setItem("sisu_token", data.token);
    setUser(data);
  };

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    persist(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await http.post("/auth/register", payload);
    persist(data);
    return data;
  };

  const logout = async () => {
    try {
      await http.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("sisu_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUser: persist }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
